module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="' +
((__t = ( styles.linkRow )) == null ? '' : __t) +
'">\n  <h4 class="' +
((__t = ( styles.heading )) == null ? '' : __t) +
'">' +
((__t = ( callout )) == null ? '' : __t) +
'</h4>\n  ' +
((__t = ( screenLink({
    action: typeof action === 'string' ? action : undefined,
    label: typeof screenLabel === 'string' ? screenLabel : undefined,
    screen: typeof screen === 'string' ? screen : undefined,
  }) )) == null ? '' : __t) +
'\n</div>\n';

}
return __p
}